module.exports = __webpack_public_path__ + "img/battery_1blue.a210c289.png";